import { DefaultAttributes } from '../types';
import { useGetAttributes } from './useGetAttributes';
import { defaultAttributesRequiredOverride } from '../constants';

type UseAttributeSuggestedResult = {
  isRequired: boolean;
  shouldRender: boolean;
}

export const useAttributeSuggested = ({
    attribute,
    showSuggestedOnly,
    additionalRequiredCondition = true,
    additionalRenderCondition = true,
}: {
  attribute: DefaultAttributes;
  showSuggestedOnly: boolean;
  additionalRequiredCondition?: boolean;
  additionalRenderCondition?: boolean;
}): UseAttributeSuggestedResult => {
    const { data: attributesConfig } = useGetAttributes();

    const getAttributeIsRequired = (field: DefaultAttributes): boolean => {
        if (defaultAttributesRequiredOverride.includes(field)) return false;

        const attributeConfig = attributesConfig?.find(({ name }) => name === field);
        if (!attributeConfig) return false;
        if (additionalRequiredCondition) return attributeConfig.required && additionalRequiredCondition;
        return attributeConfig.required;
    };

    const isRequired = getAttributeIsRequired(attribute);
    const isRequiredOverridden = defaultAttributesRequiredOverride.includes(attribute);
    const isSuggested = isRequired || isRequiredOverridden;
    const shouldRender = (!showSuggestedOnly || (showSuggestedOnly && isSuggested)) && additionalRenderCondition;

    return {
        isRequired,
        shouldRender,
    };
};
